// src/app/page.tsx
import { FC, useEffect, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { adjustToggle } from "../../utils/adjustToggle";
import { drawerWidth } from "../../constants";
import RobotPreferences from "./RobotPreferences";
import { CustomButton } from "../../components/Button";
import { useNavigate, useParams } from "react-router";
import "./index.css";
import EditBot from "./EditBot";

const ManageRobot: FC = () => {
  const theme = useTheme();
  const params = useParams();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: { sm: `calc(100% - ${drawerWidth + 90}px)` },
        ml: { sm: `${drawerWidth}px` },
        justifyContent: "center",
        alignItems: "center",
        margin: "10px",
        // height: "100vh",
      }}
      className="page-container"
    >
      {params && params.id ? <EditBot /> : <RobotPreferences />}
      <div className="chat-btn">
        <CustomButton
          text={"Back to chat"}
          submit={() => navigate("/chat")}
          bgcolor={theme.palette.background.default}
          color="rgba(33, 143, 84, 1)"
          border="1px solid rgba(33, 143, 84, 1)"
          fontWeight="bold"
          borderRadius="8px"
          width="40%"
        />
        {params && params.id ? (
          <CustomButton
            text={"Update"}
            submit={() => navigate("/manage-robot")}
            bgcolor={"rgba(33, 143, 84, 1)"}
            color={theme.palette.background.default}
            border={`1px solid ${theme.palette.background.default}`}
            fontWeight="bold"
            borderRadius="8px"
            width="40%"
          />
        ) : null}
      </div>
    </Box>
  );
};

export default ManageRobot;
